<template>
  <section
    :class="{
      'wistia-video-component': true,
    }"
  >
    <div :class="{ 'container mx-auto': true }">
      <div
        :class="{
          'video-container relative mx-auto aspect-video w-full': true,
        }"
        :style="
          embedType === 'inlineFixed' || embedType === 'popover' ?
            { maxWidth: `${props.width}${props.widthType}`, height: 'auto', margin: '0 auto' }
          : {}
        "
      >
        <client-only>
          <div
            v-if="video && video[0] && embedType === 'inlineAuto'"
            :class="{
              ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
              'h-full w-full': true,
            }"
          ></div>

          <div
            v-else-if="video && video[0] && embedType === 'popover'"
            :style="computedStyle"
            :class="{
              ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
              'popover=true popoverContent=thumbnail': true,
              'popoverAnimateThumbnail=true wistia_embed_initialized': true,
            }"
          ></div>
          <div
            v-else-if="video && video[0] && embedType === 'inlineFixed'"
            :class="{
              ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
              'absolute left-0 top-0 h-full w-full': true,
            }"
          ></div>
        </client-only>
      </div>

      <!-- Transcript -->
      <div
        v-if="showTranscript && hasTranscript && embedType === 'inlineFixed'"
        :style="computedStyle"
        :class="{
          'mt-2 rounded-10px bg-www-color-neutral-very-light p-30px': true,
        }"
      >
        <h2
          class="mb-7 border-b border-www-color-primary-lighter pb-1 font-semibold capitalize text-www-color-black"
        >
          {{ transcriptTitle }}
        </h2>

        <p
          v-if="video && video[0]"
          id="transcript"
          :class="{
            'max-h-40 overflow-y-auto font-light': true,
          }"
        >
          <wistia-transcript :media-id="video[0].hashed_id"></wistia-transcript>
        </p>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { useWindowSize } from '@vueuse/core';
import type { WistiaVideo } from '~/sanity/types';
const props = defineProps<WistiaVideo>();
useHead({
  script: [
    { key: 'wistia-script', src: 'https://fast.wistia.com/assets/external/E-v1.js', async: true },
    {
      key: 'wistia-transcript-script',
      src: 'https://fast.wistia.com/assets/external/transcript.js',
      async: true,
    },
  ],
});

const { width } = useWindowSize();
const isDesktop = computed(() => {
  return width.value > 1024;
});

const computedStyle = computed(() => {
  const widthValue = `${props.width}${props.widthType}`;
  let style;
  if (isDesktop.value) {
    style = { width: `${widthValue}`, height: '100%', margin: '0 auto', maxWidth: '100%' };
  } else {
    style = { width: '100%', height: '100%' };
  }
  return style;
});

const hasTranscript = ref(false);

onMounted(async () => {
  if (props.video && props.video[0] && props.video[0].hashed_id) {
    const response = await fetch(
      `https://fast.wistia.com/embed/medias/${props.video[0].hashed_id}.json`
    );
    const result = await response.json();
    hasTranscript.value = result.media.captions ? true : false;
  }
});
</script>
